// existingControlsColumnsHelper.tsx

import { GridColDef, GridCellParams } from '@mui/x-data-grid'
import { t } from 'i18next'
import { useNavigate } from 'react-router-dom'
import DeleteButton from '../components/common/DeleteButton'
import DriveFileRenameOutlineOutlined from '@mui/icons-material/DriveFileRenameOutlineOutlined'
import { translatePerimeter } from './helper'
import i18n from '../i18n'
import { formatTitle } from '../utils/formatTitle'
import { formatDecimal, formatPercent } from '../utils/formatNumbers'
import { numericColumn } from '../utils/dataGridStyles'

const useExistingControlsColumns = (
  SecurityId: string,
  handleDeleteClick?: (controlId: string) => void,
  disableActions?: boolean
): GridColDef[] => {
  const navigate = useNavigate()
  disableActions = disableActions ?? false

  return [
    {
      field: 'Label',
      headerName: t('Label'),
      minWidth: 150,
      flex: 1,
      renderCell: (params: GridCellParams) => (
        <span
          className="line-clamp-2 overflow-hidden text-ellipsis cursor-pointer"
          onClick={() =>
            navigate(
              `/security-controls/${SecurityId}/view-existing-Control/${params.id}`
            )
          }
        >
          {formatTitle(params.value as string)}
        </span>
      ),
    },
    {
      field: 'Description',
      headerName: t('Description'),
      minWidth: 150,
      flex: 1,
      renderCell: (params: GridCellParams) => (
        <span className="line-clamp-2 overflow-hidden text-ellipsis">
          {params.value as string}
        </span>
      ),
    },
    {
      field: 'Perimetre',
      headerName: t('Perimeter'),
      minWidth: 100,
      flex: 1,
      valueGetter: (params) => {
        const lang = i18n.language || 'en'
        return params.row?.Perimetre
          ? translatePerimeter(params.row.Perimetre, lang)
          : ''
      },
      renderCell: (params: GridCellParams) => {
        const lang = i18n.language || 'en'
        const value = params.row?.Perimetre
          ? translatePerimeter(params.row.Perimetre, lang)
          : ''
        return (
          <span className="line-clamp-2 overflow-hidden text-ellipsis">
            {value || t('No data')}
          </span>
        )
      },
    },
    {
      field: 'NombreActifCouvert',
      headerName: t('Number of Active Covered'),
      flex: 1,
      ...numericColumn(200),
      valueFormatter: ({ value }) => formatDecimal(value, { decimals: 0 }),
    },
    {
      field: 'TauxCouverture',
      headerName: t('Coverage Rate'),
      flex: 1,
      ...numericColumn(130),
      valueFormatter: ({ value }) => formatPercent(value),
    },
    {
      field: 'ControlNature',
      headerName: t('Control Nature'),
      minWidth: 100,
      flex: 1,
      renderCell: (params: GridCellParams) => (
        <span className="line-clamp-2 overflow-hidden text-ellipsis">
          {params.value as string}
        </span>
      ),
    },
    ...(!disableActions
      ? [
          {
            field: 'Action',
            headerName: t('Action'),
            minWidth: 100,
            flex: 0.5,
            renderCell: (params: GridCellParams) => (
              <>
                <DriveFileRenameOutlineOutlined
                  className="iconEdit"
                  onClick={() => navigate(`/existingControl/${params.id}`)}
                />
                <DeleteButton
                  onDelete={() =>
                    handleDeleteClick && handleDeleteClick(params.id as string)
                  }
                  item={{
                    entityType: t('existingControls', {
                      defaultValue: 'Existing control',
                    }),
                    name:
                      params.row.Label ||
                      params.row.ExistingControlName ||
                      undefined,
                    details: [
                    ],
                  }}
                />
              </>
            ),
          },
        ]
      : []),
  ]
}

export default useExistingControlsColumns
